/*
 * This file is auto-generated by ./bin/rails stimulus:manifest:update
 * Run that command whenever you add a new controller or create them with
 * ./bin/rails generate stimulus controllerName
 */

import { application } from "./application"

import AddTaxController from "./add_tax_controller"
application.register("add-tax", AddTaxController)

import InputTasteGraphController from "./input_taste_graph_controller"
application.register("input-taste-graph", InputTasteGraphController)

import RatingController from "./rating_controller"
application.register("rating", RatingController)

import SakeKuraController from "./sake_kura_controller"
application.register("sake-kura", SakeKuraController)

import SakeNameController from "./sake_name_controller"
application.register("sake-name", SakeNameController)

import SakeSizeController from "./sake_size_controller"
application.register("sake-size", SakeSizeController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import ShowTasteGraphController from "./show_taste_graph_controller"
application.register("show-taste-graph", ShowTasteGraphController)

import SimpleLightboxController from "./simple_lightbox_controller"
application.register("simple-lightbox", SimpleLightboxController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)
